// CreateJobModal.tsx (separate file)
import React, { createContext, useContext, useState } from 'react';
import CustomerCreateJobModal from './CustomerCreateJobModal';

interface CreateJobModalContextType {
  openModal: () => void;
  closeModal: () => void;
}

const CreateJobModalContext = createContext<CreateJobModalContextType | undefined>(undefined);

export const CreateJobModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <CreateJobModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <CustomerCreateJobModal 
        isOpen={isModalOpen} 
        toggle={closeModal}
        onJobCreated={() => {
          closeModal();
          // Add any other post-creation logic here
        }}
      />
    </CreateJobModalContext.Provider>
  );
};

export const useCreateJobModal = () => {
  const context = useContext(CreateJobModalContext);
  if (!context) {
    throw new Error('useCreateJobModal must be used within a CreateJobModalProvider');
  }
  return context;
};